import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=2cf2e2f0&scoped=true"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"
import style0 from "./contract.vue?vue&type=style&index=0&id=2cf2e2f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2e2f0",
  null
  
)

export default component.exports